export default __webpack_public_path__ + "static/media/appClosePatient.267cd6cd.svg";